import moment from 'moment';

const MONTHS = [
  'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
  'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря',
];

const WORK_TYPE_LABELS = {
  processing: 'Обработка',
  review: 'Проверка',
};

export const formatAmount = (value) => Number(value ?? 0)
  .toLocaleString('ru-RU', { maximumFractionDigits: 2 });

export const workTypeLabel = (plan) => WORK_TYPE_LABELS[plan?.work_type] ?? plan?.work_type ?? '';

export const planKey = (plan) => `${plan.crm_plan_id}:${plan.type}:${plan.work_type}`;

export const periodLabel = (item) => {
  const start = moment.parseZone(item.start_at);
  const end = moment.parseZone(item.end_at);

  return `${start.date()}–${end.date()} ${MONTHS[end.month()]} ${end.year()}`;
};

export const periodOptions = (items) => items.map((item) => ({
  value: item.key,
  label: periodLabel(item),
}));
